module.exports = __webpack_public_path__ + "media/images/flags/gd-b446a44dff915db188691a49dd65a49e.svg";